import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { createApp } from 'vue';
import App from './App.vue';
import { ref, reactive } from 'vue'
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from './quasar-user-options';
// import mitt from 'mitt';

// Firebase

// import { getFirestore } from 'firebase/firestore/lite';
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";

// import './registerServiceWorker';

// const CACHE_VERSION = Math.random() * 999;
// import '../public/service-worker.js';


// Mitt
// const eventBus = mitt();

// Vue
const vueApp = createApp(App).use(Quasar, quasarUserOptions);
// vueApp.config.globalProperties.eventBus = eventBus;



// Firebase
const firebaseConfig = {
    apiKey: "AIzaSyA_4ilyvb1FR-SvJr9U_oVGHYdvkO5fiys",
    authDomain: "focus-on-america.firebaseapp.com",
    projectId: "focus-on-america",
    storageBucket: "focus-on-america.appspot.com",
    messagingSenderId: "271251517698",
    appId: "1:271251517698:web:0f0fb9e2c9a224aa49521b"
};


const fireApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(fireApp);

const db = getFirestore();

vueApp.config.globalProperties.fire_app = fireApp;
vueApp.config.globalProperties.fire_db = db;
vueApp.config.globalProperties.donorMatch = "";

enableIndexedDbPersistence(db)
    .catch((err) => {
        if (err.code == 'failed-precondition') {
            console.log("failed-precondition");
            // Multiple tabs open, persistence can only be enabled
            // in one tab at a a time.
            // ...
        } else if (err.code == 'unimplemented') {
            console.log("unimplemented");
            // The current browser does not support all of the
            // features required to enable persistence
            // ...
        }
    });





console.log("%cFirebase ready.", "color:orange;font-size:20px;");


// vueApp.config.globalProperties.chance = new Chance();

// Vue

// https://stackoverflow.com/questions/63100658/add-global-variable-in-vue-js-3
// vueApp.config.globalProperties.selectedCandidate = reactive(null);
// vueApp.config.globalProperties.selectedCandidateName = ref(null);
// vueApp.config.globalProperties.selectedCandidate = reactive(null);
vueApp.config.globalProperties.styleError = "font-family:monospace;color:red:font-size:18px;";
vueApp.config.globalProperties.styleList = "font-family:monospace;color:white:font-size:14px;";



// vueApp.mixin({
//     methods: {
//         modeGetValues(mode) {

//             if (mode == "light") {
//                 return { "text": "Dark Mode", "icon": "dark_mode" };
//             } else {
//                 return { "text": "Light Mode", "icon": "light_mode" };
//             }
//         },
//         modeToggle() {
//             if (global.mode == "light") {
//                 global.mode = "dark";

//                 this.$q.dark.set(true);
//             }
//             else {
//                 global.mode = "light";

//                 this.$q.dark.set(false);
//             }
//         },
//     },
// });


vueApp.mount('#app');

